export default { commitHash: '13158c8', version: '13158c8' };
